import { v4 as uuid } from 'uuid';
import { RoomStructureItemType } from '../../../enums/RoomStructureItemType';
import {
  RoomJSONStructureItem,
  RoomTemplateSchema,
} from '../../../definitions/schemas';

/**
 * Re-assigns a fresh uuid to any text-box structure item that came back from
 * the server with a blank id. Template text boxes are saved with an empty id
 * (so the backend forks a new text content); on reload we restore a non-empty
 * id so the item can be matched/rendered again.
 *
 * Shared by the template root reload (postProcessTemplate) and the folder
 * reload (useFolderData) so both behave identically.
 */
export const restoreTextBoxIds = (
  items: RoomJSONStructureItem[] = []
): RoomJSONStructureItem[] =>
  items.map((item) => {
    if (item.type === RoomStructureItemType.TextBox && !item.id) {
      return { ...item, id: uuid() };
    }
    return item;
  });

export const postProcessTemplate = (
  template: RoomTemplateSchema
): RoomTemplateSchema => ({
  ...template,
  structure: {
    ...template?.structure,
    items: restoreTextBoxIds(template?.structure?.items),
  },
});
